import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EvntCard from '../components/evnt/EvntCard';
import NavbarText from '../components/NavbarText';
import axios from "axios";

interface EvntList {
  name: string;
  engName: string;
  prepStrtDt: string;
  prepEndDt: string;
  evntStrtDt: string;
  evntEndDt: string;
  dwlnStrtDt: string;
  dwlnEndDt: string;
  exbtPlc: string;
  worker: string;
  descHidden: boolean;
};

// AUTH === 'KOX' 만 접근 가능
export default function Event() {
  const navigate = useNavigate();
  const [evntList, setEvntList] = useState<EvntList[]>();
  const evntRefs = useRef({}) as React.MutableRefObject<any>;
  const arrowDownRefs = useRef({}) as React.MutableRefObject<any>;
  const arrowUpRefs = useRef({}) as React.MutableRefObject<any>;
  const foldHandler = (param: any) => {
    if (evntRefs.current[param].hidden === true) {
      evntRefs.current[param].hidden = false;
      arrowUpRefs.current[param].hidden = false;
      arrowDownRefs.current[param].hidden = true;
    } else {
      evntRefs.current[param].hidden = true;
      arrowDownRefs.current[param].hidden = false;
      arrowUpRefs.current[param].hidden = true;
    };
  };
  useEffect(() => {
    // axios로 evnt data 가져오기
    fn_retrieveEvntList();

  }, []);

  const fn_retrieveEvntList = async () => {
    const rtrnData = await axios.post('admin/api/evnt/retrieveTodayEvntInfoList', {})
    setEvntList(rtrnData.data);
  }

  return (
    <div className='w-screen h-[calc(100dvh)]'>
      <NavbarText backEvent={() => navigate(-1)}>행사 조회</NavbarText>
      <div className='h-[calc(100%-52px)] md:h-[calc(100%-130px)] overflow-auto scrollbar-hide bg-white text-txtBlack rounded-t-[20px] md:rounded-t-[50px] flex flex-col items-center '>
        <div className='mb-20 md:mb-[50px]'>
          <div className='flex items-center mt-30 ml-18 md:mt-[75px] md:ml-[45px]'>
            <p className='font-preBold text-15 mr-4 md:text-37 md:mr-[10px]'>오늘의 행사</p>
            <p className='text-point text-15 md:text-37 font-preBold'>{!evntList ? 0 : evntList?.length}<span className='text-txtBlack ml-2 md:ml-[5px]'>건</span></p>
          </div>
          {evntList?.map((item, idx) => {
            return (
              <EvntCard key={idx} evnt={item} evntRef={evntRefs} arrowDownRef={arrowDownRefs} arrowUpRef={arrowUpRefs} foldHandler={foldHandler} />
            );
          })}
        </div>
      </div>
    </div>
  );
}

